import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import r from "../../shared-lib/braze-shared-lib.js";

var _t = /*#__PURE__*/function () {
  function _t(t, e, s) {
    _classCallCheck(this, _t);

    null == t && (t = r.it.nt()), s = parseInt(s), (isNaN(s) || 0 === s) && (s = new Date().valueOf()), this.eu = t, this.rh = s, this.mh = new Date().valueOf(), this.ah = e;
  }

  _createClass(_t, [{
    key: "ss",
    value: function ss() {
      return {
        g: this.eu,
        e: this.ah,
        c: this.rh,
        l: this.mh
      };
    }
  }], [{
    key: "yn",
    value: function yn(t) {
      if (null == t || null == t.g) return null;
      var e = new _t(t.g, t.e, t.c);
      return e.mh = t.l, e;
    }
  }]);

  return _t;
}();

export { _t as default };